import { render, staticRenderFns } from "./LearningGroupAddStudentsTable.vue?vue&type=template&id=572449a0&"
import script from "./LearningGroupAddStudentsTable.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupAddStudentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports